import React from 'react';
import API_BASE from '../config';

const DPR = 2; // render at 2× for sharp Retina display

const MoleculeImage = ({ smiles, molId, innId, width = 200, height = 200, alt = "Molecule", version }) => {
  const params = molId
    ? `molid=${molId}&width=${width * DPR}&height=${height * DPR}`
    : innId
    ? `inn_id=${innId}&width=${width * DPR}&height=${height * DPR}`
    : `smiles=${encodeURIComponent(smiles)}&width=${width * DPR}&height=${height * DPR}`;
  const imageUrl = `${API_BASE}/molecule/image?${params}${version ? `&v=${version}` : ''}`;

  return (
    <img
      src={imageUrl}
      alt={alt}
      width={width}
      height={height}
      style={{ display: 'block' }}
      onError={(e) => {
        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2VlZSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5ObyBJbWFnZTwvdGV4dD48L3N2Zz4=';
      }}
    />
  );
};

export default MoleculeImage;
